__webpack_require__.p = "/monster-manual/";